import WebRequest from './web-request';
import EvoRequest from './tv_evo-request';
import type * as AxiosType from 'axios';

export const request = import.meta.env.EVO ? new EvoRequest() : new WebRequest();


export {
  AxiosType,
};

